import {processApiRequest} from '../../Common/saga';
import * as ACTION from './constants';
import apiService from './apiService';
import {notification} from 'antd';
import {router} from '../../../system/routing';
import {t} from '../../../system/i18n';

export function* createShippingPartner(action) {
    yield processApiRequest(ACTION.CREATE_SHIPPING_PARTNER, () => apiService.createShippingPartner(action.payload), action.payload);
}

export function* createShippingPartnerSuccess() {
    yield notification['success']({
        message: t('common:message.create_shipping_partner_success'),
        className:'_create_shipping_partner_success'
    });
    yield router.redirect('/config/shipping-partners');
}